<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessImportHistory.page.templateName')" prop="templateName">
            <BjInput v-model="queryParams.templateName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessImportHistory.page.templateCode')" prop="templateCode">
            <BjInput v-model="queryParams.templateCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button v-permission:BusinessImportGeneralAdd type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'templateType'">
                {{ $t(IMPORT_GENERAL_TYPE_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <el-tag v-else-if="col.prop === 'enabledFlag'" :type="scope.row[col.prop] ? 'success' : 'info'">{{ $t(STATUS_ENABLED_NUM.bjGet(scope.row[col.prop])) }}</el-tag>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="{ row }">
              <el-button v-permission:BusinessImportGeneralEdit type="text" class="edit-btn" @click="onEdit(row)">{{ $t('editText') }}</el-button>
              <el-button v-permission:BusinessImportGeneralIndex_Delete :disabled="!!row.enabledFlag" type="text" @click="onDelete(row)">{{ $t('delText') }}</el-button>
              <el-button v-permission:BusinessImportGeneralIndex_Export :disabled="!row.enabledFlag" type="text" @click="onExport(row)">{{ $t('exportText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { importApi, settingApi } from '@/api';
import { IMPORT_GENERAL_TYPE_LIST, STATUS_ENABLED_NUM } from '@/utils/constants';
import { downloadBlob, getEnvGlobalConfig } from '@/utils/index';
const DEFAULT_BUCKET_NAME = getEnvGlobalConfig('VUE_APP_UPLOAD_BUCKET_NAME');
export default {
  name: 'BusinessImportGeneralIndex',
  mixins: [pageMiXin],
  data() {
    return {
      IMPORT_GENERAL_TYPE_LIST,
      STATUS_ENABLED_NUM,
      colSpan: 6,
      selection: true,
      queryApi: importApi.getImportTemplateHeaders,
      // 查询参数
      queryParams: {
        templateName: null,
        templateCode: null,
      },
      labelsVersion: 1,
      labelList: [
        { label: 'BusinessImportHistory.page.templateName', prop: 'templateName', isCheck: true, disabled: false },
        { label: 'BusinessImportHistory.page.templateCode', prop: 'templateCode', isCheck: true, disabled: false },
        { label: 'BusinessImportHistory.page.TemplateType', prop: 'templateType', isCheck: true, disabled: false },
        { label: 'BusinessImportHistory.page.CustomTemplateName', prop: 'templateFileName', isCheck: true, disabled: false },
        { label: 'BusinessImportHistory.page.Description', prop: 'description', isCheck: true, disabled: false },
        { label: 'table.statusText', prop: 'enabledFlag', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150},
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 新增 */
    onAdd() {
      this.$toPage('BusinessImportGeneralAdd');
    },
    /** 编辑 */
    onEdit(row) {
      const { id } = row;
      this.$toPage('BusinessImportGeneralEdit', { id });
    },
    onExport(row) {
      // 存在自定义
      if (row.templateUrl) {
        const { templateUrl, templateFileName } = row;
        settingApi
          .downloadFileByUrl({
            bucketName: DEFAULT_BUCKET_NAME,
            url: templateUrl,
          })
          .then(res => {
            downloadBlob(res, templateFileName);
          });
      } else {
        const { templateCode, templateName } = row;
        this.exportApi({ templateCode, tenantId: 0 }, templateName);
      }
    },
    /** 删除 */
    onDelete(row) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.deleteApi(row);
        })
        .catch(() => {});
    },
    /** 导出 */
    exportApi(data, fileName) {
      console.log(data, fileName);
      importApi['exportExcelImportTemplateHeaders'](data).then(res => {
        downloadBlob(res, fileName + '.xlsx');
      });
    },
    deleteApi(data) {
      importApi.deleteImportTemplateHeaders(data).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
